<!--
 * @description: 巡检计划
 * @author: liyubao | xufuxing
 * @version: 1.0
-->
<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-select @change="handleFilter" size="small" style="width: 200px;" class="filter-item"
          v-model="listQuery.State">
          <el-option label="新建" value="新建"></el-option>
          <el-option label="启动" value="启动"></el-option>
          <el-option label="已完成" value="已完成"></el-option>
        </el-select>
        <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="small" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" v-loading="listLoading" @row-dblclick="onBtnClicked('btnEdit')"
          @row-click="rowClick" @selection-change="handleSelectionChange" :enable-sorting="true"
          :enable-custom-filter="true" @sort-change="handleSortChange"
          @filter-change="handleTableFilterChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="1000px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible" @close="resetTemp">
        <el-row :gutter="10">
          <el-form ref="dataForm" :model="temp" :rules="rules" size="medium" label-width="80px" label-position="left">

            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="名称" prop="name">
                    <el-input v-model="temp.name" placeholder="请输入名称" clearable :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="仓库" prop="storeName">
                    <el-select v-model="temp.storeName" @change="storeChange" filterable placeholder="请选择仓库"
                      :style="{ width: '100%' }">
                      <el-option v-for="(item, index) in Storetions" :key="index" :label="item.storeName"
                        :value="item.storeName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="部门" prop="department">
                    <el-select v-model="temp.department" @change="departmentChange" filterable placeholder="请选择部门"
                      :style="{ width: '100%' }">
                      <el-option v-for="(item, index) in Deptions" :key="index" :label="item.useDepartment"
                        :value="item.useDepartment">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="开始日期" prop="startTime">
                    <el-date-picker v-model="temp.startTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      :style="{ width: '100%' }" placeholder="请选择开始日期" clearable></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="结束日期" prop="endTime">
                    <el-date-picker v-model="temp.endTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      :style="{ width: '100%' }" placeholder="请选择结束日期" clearable></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="创建人" prop="createName">
                    <el-input v-model="temp.createName" placeholder="请输入创建人" readonly :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="说明" prop="description">
                    <el-input type="textarea" v-model="temp.description" placeholder="请输入说明" :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="24">
              <el-row>
                <el-divider content-position="left">巡检明细</el-divider>
                <el-row :gutter="10" style="margin-bottom: 13px; display: flex; align-items: center;">
                  <el-col :span="6">
                    <el-select v-model="filterStore" placeholder="筛选仓库" size="mini" clearable
                      @change="handleFilterChange" style="width: 100%">
                      <el-option v-for="(item, index) in [...new Set(tableData.map(x => x.storeName))]"
                        :key="'store' + index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <el-select v-model="filterDepartment" placeholder="筛选部门" size="mini" clearable
                      @change="handleFilterChange" style="width: 100%">
                      <el-option v-for="(item, index) in [...new Set(tableData.map(x => x.useDepartment))]"
                        :key="'dept' + index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <el-select v-model="userId" placeholder="请选择巡检人" size="mini" style="width: 100%">
                      <el-option v-for="(item, index) in userptions" :key="index" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2">
                    <el-button size="mini" @click="toggleNoPersonFilter" :type="filterNoPerson ? 'primary' : ''">
                      {{ filterNoPerson ? '全部' : '无人' }}
                    </el-button>
                  </el-col>
                  <el-col :span="2">
                    <el-button size="mini" @click="handleModify">确认</el-button>
                  </el-col>
                  <el-col :span="2">
                    <el-button size="mini" @click="resetFilter">重置</el-button>
                  </el-col>
                </el-row>

                <el-pagination small layout="prev, pager, next" :page-size="frontendPagination.pageSize"
                  :total="frontendPagination.total" :current-page.sync="frontendPagination.currentPage"
                  @current-change="handleFrontendPageChange" style="margin-bottom: 10px;" />
                <el-table :data="paginatedTableData" @selection-change="SelectionChange" ref="multipleTable"
                  height="300" border v-loading="listLoading">
                  <el-table-column type="selection" width="55" />
                  <el-table-column prop="storeName" label="仓库" width="100"></el-table-column>
                  <el-table-column prop="useDepartment" label="部门" width="100"></el-table-column>
                  <el-table-column prop="assetCode" label="资产编号" width="120"></el-table-column>
                  <el-table-column prop="assetName" label="资产名称" width="180"></el-table-column>
                  <el-table-column prop="inspectionPerson" label="巡检人" width="120"></el-table-column>
                </el-table>
              </el-row>
            </el-col>
          </el-form>
        </el-row>

        <div slot="footer">
          <el-button size="small" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="small" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="small" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as inspectionPlanss from '@/api/basic/inspectionPlanss'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
import store from '../../../store'

export default {
  name: 'inspectionPlans',
  components: { Sticky, permissionBtn, Pagination, AuthTable },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      filteredList: null, // 过滤后的列表数据
      total: 0,
      listLoading: true,
      tableData: [],
      originalTableData: [], // 保存原始数据用于重置
      userId: '',
      filterStore: '', // 仓库筛选条件
      filterDepartment: '', // 部门筛选条件
      filterNoPerson: false, // 是否筛选未设置巡检人
      frontendPagination: {
        pageSize: 200,
        currentPage: 1,
        total: 0
      },
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
        State: ''
      },
      Storetions: [],
      Deptions: [],
      userptions: [], // 巡检人
      temp: {
        inspectionCode: undefined,
        name: undefined,
        storeName: undefined,
        department: undefined,
        description: undefined,
        createName: undefined,
        startTime: null,
        endTime: null,
        state: '新建'
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      selectedRows: [],
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        storeName: [],
        department: [],
        startTime: [{
          required: true,
          message: '请选择开始日期',
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束日期',
          trigger: 'change'
        }],
        previousStoreName: '',
        previousDepartment: '',
      },
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('inspectionCode', '巡检计划编号', true, true, '', '', 'string', 'nvarchar', 'InspectionCode', '120px'),
      new ColumnDefine('name', '名称', true, true, '', '', 'string', 'nvarchar', 'Name', '120px'),
      new ColumnDefine('department', '部门', true, true, '', '', 'string', 'nvarchar', 'Department', '120px'),
      new ColumnDefine('storeName', '仓库', true, true, '', '', 'string', 'nvarchar', 'storeName', '100px'),
      new ColumnDefine('description', '说明', true, true, '', '', 'string', 'nvarchar', 'Description', '120px'),
      new ColumnDefine('startTime', '开始日期', true, true, '', '', 'DateTime', 'datetimeoffset', 'StartTime', '120px'),
      new ColumnDefine('endTime', '结束日期', true, true, '', '', 'DateTime', 'datetimeoffset', 'EndTime', '120px'),
      new ColumnDefine('state', '状态', true, true, '', '', 'string', 'varchar', 'State', '100px'),
      new ColumnDefine('createName', '创建人', true, true, '', '', 'string', 'varchar', 'CreateName', '100px'),
      new ColumnDefine('createdAt', '创建日期', true, true, '', '', 'DateTime', 'datetimeoffset', 'CreatedAt', '120px'),
    ]
    this.getList()
    this.GetStoretions()
    this.GetDeptions()
    this.GetInspectionPerson()
  },
  computed: {
    paginatedTableData() {
      const start = (this.frontendPagination.currentPage - 1) * this.frontendPagination.pageSize;
      const end = start + this.frontendPagination.pageSize;
      return this.tableData.slice(start, end);
    }
  },
  methods: {
    handleModify() {
      // 批量更新巡检人
      if (!this.userId) {
        this.$message({
          message: '请先选择巡检人',
          type: 'error',
        })
        return
      }
      if (this.selectedRows.length < 1) {
        this.$message({
          message: '至少选择一行',
          type: 'error',
        })
        return
      }
      var user = this.userptions.find(x => x.id == this.userId)
      console.log(user)
      // 批量更新
      this.tableData.forEach((item) => {
        if (this.selectedRows.find(x => x.assetCode == item.assetCode)) {
          item.inspectionPerson = user.name,
            item.inspectionPersonId = user.id
        }
      })
      this.$refs.multipleTable.clearSelection()
      this.$message({
        message: '修改成功',
        type: 'success'
      })
    },

    handleFilterChange() {
      // 保存原始数据
      if (!this.originalTableData.length) {
        this.originalTableData = [...this.tableData];
      }

      // 筛选表格数据
      let filteredData = [...this.originalTableData];

      if (this.filterStore) {
        filteredData = filteredData.filter(x => x.storeName === this.filterStore);
      }
      if (this.filterDepartment) {
        filteredData = filteredData.filter(x => x.useDepartment === this.filterDepartment);
      }
      if (this.filterNoPerson) {
        filteredData = filteredData.filter(x => !x.inspectionPerson);
      }

      this.tableData = filteredData;
      this.frontendPagination.total = filteredData.length;
      this.frontendPagination.currentPage = 1;
    },

    // 处理表格筛选（主表格）
    handleTableFilterChange(filteredData) {
      this.filteredList = filteredData;
      this.list = filteredData;
      this.total = filteredData.length;
    },

    handleFrontendPageChange(page) {
      this.frontendPagination.currentPage = page;
    },

    toggleNoPersonFilter() {
      this.filterNoPerson = !this.filterNoPerson;
      this.handleFilterChange();
    },

    resetFilter() {
      this.filterStore = '';
      this.filterDepartment = '';
      this.filterNoPerson = false;
      this.tableData = [...this.originalTableData];
    },

    // 获取巡检人
    async GetInspectionPerson() {
      try {
        let result = await inspectionPlanss.GetInspectionPerson(store.getters.tenantid)
        this.userptions = result.result
      } catch (error) {
        console.error('获取巡检人失败', error)
      }
    },

    async storeChange(newValue) {
      if (newValue !== this.previousStoreName) {
        this.previousStoreName = newValue; // 记录当前选中的值
        try {
          // 获取巡检明细
          const result = await inspectionPlanss.QueryInspectionDetail(this.previousStoreName, this.previousDepartment)
          this.tableData = result.result
          this.originalTableData = [...this.tableData] // 保存原始数据
          this.frontendPagination.total = this.tableData.length // 初始化分页总数
          this.frontendPagination.currentPage = 1 // 重置到第一页
        } catch (error) {
          console.error('获取仓库数据失败', error);
        }
      }
    },

    async departmentChange(newValue) {
      if (newValue !== this.previousDepartment) {
        this.previousDepartment = newValue; // 记录当前选中的值
        try {
          // 获取巡检明细
          const result = await inspectionPlanss.QueryInspectionDetail(this.previousStoreName, this.previousDepartment)
          this.tableData = result.result
          this.originalTableData = [...this.tableData] // 保存原始数据
          this.frontendPagination.total = this.tableData.length // 初始化分页总数
          this.frontendPagination.currentPage = 1 // 重置到第一页
        } catch (error) {
          console.error('获取部门数据失败', error);
        }
      }
    },
    GetStoretions() {
      inspectionPlanss.GetStoretions().then((response) => {
        this.Storetions = response.result
        this.Storetions.unshift({ id: 'all', storeName: '全部' })
      })
    },
    GetDeptions() {
      inspectionPlanss.GetDeptions().then((response) => {
        this.Deptions = response.result
        this.Deptions.unshift({ id: 'all', useDepartment: '全部' })
      })
    },
    SelectionChange(val) {
      this.selectedRows = val;
    },
    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'start':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          if (this.multipleSelection[0].state != '新建') {
            this.$message({
              message: '只能对新建状态的巡检计划进行启动',
              type: 'error',
            })
            return
          }
          inspectionPlanss.StartInspection(this.multipleSelection[0].id).then(() => {
            this.$notify({
              title: '成功',
              message: '启动成功',
              type: 'success',
              duration: 2000,
            })
            this.getList()
          })
          break;
        case 'btnFinish':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行完成',
              type: 'error',
            })
            return
          }
          if (this.multipleSelection[0].state != '启动') {
            this.$message({
              message: '只能对启动状态的巡检计划进行完成',
              type: 'error',
            })
            return
          }
          inspectionPlanss.FinishInspection(this.multipleSelection[0].id).then(() => {
            this.$notify({
              title: '成功',
              message: '完成成功',
              type: 'success',
              duration: 2000,
            })
            this.getList()
          })
          break;
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          if (this.multipleSelection[0].state != '新建') {
            this.$message({
              message: '只能对新建状态的巡检计划进行删除',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('巡检计划', callback)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      inspectionPlanss.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.previousStoreName = '';
      this.previousDepartment = '';
      this.tableData = [];
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
      this.temp.state = '新建'; // 设置默认状态
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate((val) => {
        if (!val) return;
        if (this.tableData.length <= 0) {
          this.$alert('明细不能为空', '系统消息', {
            confirmButtonText: '确定',
          });
          return
        }
        var json = {
          main: this.temp,
          tabledata: this.tableData
        }

        inspectionPlanss.add(JSON.stringify(json)).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
          this.getList()
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      inspectionPlanss.get(row.id).then((response) => {
        this.temp = response.result
        this.previousStoreName = response.result.storeName
        this.previousDepartment = response.result.department
        return inspectionPlanss.GetInspectionDetail(response.result.inspectionCode);
      }).then((response) => {
        this.tableData = response.result
      }).catch((error) => {
        console.error('获取数据失败', error)
      });

      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        var tempData = {
          main: this.temp,
          tabledata: this.tableData
        }
        console.log(tempData)
        inspectionPlanss.update(JSON.stringify(tempData)).then(() => {
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
          this.getList()
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(inspectionPlanss, rows)
    },

    // 处理表格排序
    handleSortChange({ prop, order }) {
      if (!prop || !order) return;

      const data = this.filteredList || this.list;
      const sortedData = [...data];

      sortedData.sort((a, b) => {
        let valueA = a[prop];
        let valueB = b[prop];

        // 处理数字类型
        if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
          valueA = Number(valueA);
          valueB = Number(valueB);
        }

        // 处理日期类型
        if (valueA && valueB && !isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
          valueA = new Date(valueA);
          valueB = new Date(valueB);
        }

        // 按照顺序排序
        if (order === 'ascending') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });

      this.list = sortedData;
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
